const sizeGuideLink = document.querySelector('[data-size-guide-link]');

if (sizeGuideLink) {
  sizeGuideLink.addEventListener('click', function () {
    setTimeout(() => {
      const sizeGuideModal = document.querySelector<HTMLElement>(
        '.c-modal .c-size-guide'
      );
      const enableSizeGuideToggle = sizeGuideModal?.getAttribute(
        'data-enable-size-guide-toggle'
      );

      if (enableSizeGuideToggle == 'true') {
        const sizeGuideTitle =
          sizeGuideModal?.getAttribute('data-product-title') || '';
        const sizeGuideTable: any = sizeGuideModal?.querySelector('table');
        const sizeGuideTogglesContainer = sizeGuideModal?.querySelector(
          '.size-guide__unit-toggles'
        );

        if (sizeGuideTogglesContainer) {
          // Toggles have already been added to Modal
        } else {
          // Need to add Toggles to Modal
          const tableCaption = sizeGuideTable.createCaption();
          const insert_sizeGuideToggle =
            `<div class="size-guide__unit-toggles">
              <div class="size-guide__title">` +
            sizeGuideTitle +
            `</div>
              <!-- <div class="size-guide__toggle-container">
                <div class="size-guide__toggle" data-size-guide-unit="metric">CM</div>
                <div class="size-guide__divider"></div>
                <div class="size-guide__toggle" data-size-guide-unit="imperial">IN</div>
              </div> -->
              <div class="size-guide__toggle-container">
                IN
                <label class="size-guide__switch">
                  <input type="checkbox" class="switch__checkbox">
                  <span class="switch__slider"></span>
                </label>
                CM
              </div>
            </div>`;
          tableCaption.innerHTML = insert_sizeGuideToggle;
        }

        // Add class to table cells containing the Size Guide Elements
        const sizeUnitsCells = sizeGuideTable.querySelectorAll('td');
        sizeUnitsCells?.forEach((cell: any) => {
          const sizeGuideElements_classes = cell.querySelectorAll(
            'span[class^="size-guide--"]'
          );
          const sizeGuideElement_metric = cell.querySelector('metric');
          const sizeGuideElement_imperial = cell.querySelector('imperial');
          const sizeGuideElement_divider = cell.querySelector('divider');
          if (
            sizeGuideElements_classes.length > 1 ||
            sizeGuideElement_metric ||
            sizeGuideElement_imperial ||
            sizeGuideElement_divider
          ) {
            cell.classList.add('size-guide__container');
          }
        });

        // Data attribute is set using section settings (liquid)
        var currentUnit = sizeGuideModal?.getAttribute('data-size-guide-unit');

        // If the user has chosen a new unit...
        const user_sizeGuideUnit = localStorage.getItem('size-guide-unit');
        if (user_sizeGuideUnit) {
          // ... update the data attribute
          sizeGuideModal?.setAttribute(
            'data-size-guide-unit',
            user_sizeGuideUnit
          );
          // ... update the variable
          currentUnit = user_sizeGuideUnit;
        }

        const updateUnit = (newUnit: any) => {
          currentUnit = newUnit;
          sizeGuideModal?.setAttribute('data-size-guide-unit', newUnit);
          localStorage.setItem('size-guide-unit', newUnit);
        };

        // Toggles (Typographic Style)
        const sizeGuideToggles = sizeGuideModal?.querySelectorAll(
          '.size-guide__toggle'
        );
        sizeGuideToggles?.forEach((toggle) => {
          const toggleUnit = toggle.getAttribute('data-size-guide-unit') || '';
          if (toggleUnit == currentUnit) {
            toggle.classList.add('size-guide__toggle--active');
          }
          toggle.addEventListener('click', () => {
            sizeGuideToggles.forEach((toggle) => {
              toggle.classList.remove('size-guide__toggle--active');
            });
            toggle.classList.add('size-guide__toggle--active');
            updateUnit(toggleUnit);
          });
        });

        // Switch Style -- TRUE = Metric (CM)
        const toggleSwitch =
          sizeGuideModal?.querySelector<HTMLInputElement>('.switch__checkbox');
        if (toggleSwitch && currentUnit == 'metric') {
          toggleSwitch.checked = true;
        }
        toggleSwitch?.addEventListener('click', () => {
          if (currentUnit == 'metric') {
            updateUnit('imperial');
          } else if (currentUnit == 'imperial') {
            updateUnit('metric');
          }
        });
      }
    }, 10);
  });
}
